<template>
    <div>
        <!--头部-->
        <div class="divhead">
            <h1 class="atitle">我的邀请链接</h1>
            <div class="divlink" v-if="shareCode == ''">
                <div class="subtitle">您目前还未开通推广链接</div>
                <div class="vc-flex " style="margin-top: 15px;">
                    <div @click="openUserShare" class="bnt-main focus-s">
                        <span>立即开通</span>
                    </div>
                </div>
            </div>
            <div class="divlink" v-else>
                <div class="mlink">{{ shareLink }}</div>
                <div class="vc-flex " style="margin-top: 15px;">
                    <div @click="copyShareLink" class="bnt-main focus-s">
                        <SvgIcon svgname="ic_copy" :size="16" fill="white"></SvgIcon>
                        <span class="mgl5">复制链接</span>
                    </div>
                </div>
            </div>
        </div>
        <!--华丽分割线-->
        <div class="mgt20">
            <div class="sptitle">关联</div>
            <div class="grid">
                <div class="card-item">
                    <div class="subtitle">今日访客</div>
                    <div class="lbnum">
                        <span>{{ todayVisitCount }}</span>
                        <span class="lbuint">次</span>
                    </div>
                </div>
                <div class="card-item">
                    <div class="subtitle">今日注册量</div>
                    <div class="lbnum">
                        <span>{{ todayRegisterCount }}</span>
                        <span class="lbuint">人</span>
                    </div>
                </div>
                <div class="card-item">
                    <div class="subtitle">累计注册量</div>
                    <div class="lbnum">
                        <span>{{ totalRegisterCount }}</span>
                        <span class="lbuint">人</span>
                    </div>
                </div>
            </div>
        </div>
        <!--华丽分割线-->
        <div class="mgt20">
            <div class="sptitle">收益</div>
            <div class="grid">
                <div class="card-item">
                    <div class="subtitle">今日收益</div>
                    <div class="lbnum">
                        <span>{{ todayIncome }}</span>
                        <span class="lbuint">元</span>
                    </div>
                </div>
                <div class="card-item">
                    <div class="subtitle">可提佣金</div>
                    <div class="lbnum">
                        <span>{{ haveMoney }}</span>
                        <span class="lbuint">元</span>
                    </div>
                </div>
                <div class="card-item">
                    <div class="subtitle">已提佣金</div>
                    <div class="lbnum">
                        <span>{{ passMoney }}</span>
                        <span class="lbuint">元</span>
                    </div>
                </div>
                <div class="card-item">
                    <div class="subtitle">累计佣金</div>
                    <div class="lbnum">
                        <span>{{ totalMoney }}</span>
                        <span class="lbuint">元</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SvgIcon from '@/components/SvgIcon.vue';
import httpClient from '@/commom/http/httpClient';
export default {
    name: 'ShareDataView',
    components: {
        SvgIcon
    },
    props: {
    },
    data() {
        return {
            shareCode: "",
            todayVisitCount: 0,
            todayRegisterCount: 0,
            totalRegisterCount: 0,
            todayIncome: 0,
            haveMoney: 0,
            passMoney: 0,
            totalMoney: 0,
            shareLink: ""
        }
    },
    mounted: function () {
        this.loadData()
    },
    methods: {
        ///加载数据
        loadData: function () {
            var that = this
            httpClient.invoke("ShareAPI.GetShareInfo", {}, function (res) {
                if (res.error) {
                    that.$message.error(res.error)
                    return
                }
                that.shareCode = res.shareCode
                that.todayVisitCount = res.todayVisitCount
                that.todayRegisterCount = res.todayRegisterCount
                that.totalRegisterCount = res.totalRegisterCount
                that.todayIncome = res.todayIncome
                that.haveMoney = res.haveMoney
                that.passMoney = res.passMoney
                that.totalMoney = res.totalMoney
                that.shareLink = "https://comekey.com/t/" + that.shareCode
            })
        },
        ///开通推广链接
        openUserShare() {
            var that = this
            httpClient.invoke("ShareAPI.CreateShare", {}, function (res) {
                if (res.error) {
                    that.$message.error(res.error)
                    return
                }
                if (!res.success) {
                    that.$message.error(res.message)
                    return
                }
                that.$message.success("开通推广链接成功")
                that.loadData()
            })
        },
        ///复制推广链接
        copyShareLink() {
            var that = this
            navigator.clipboard.writeText(this.shareLink)
                .then(() => {
                    that.$message.success("已复制链接")
                })
                .catch(err => {
                    that.$message.error("复制推广链接失败")
                });
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.divlink {
    margin-top: 20px;
}

.sptitle {
    font-weight: bold;
    color: var(--ek-text-color2);
}

.grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 20px;
    padding-top: 20px;
}

.card-item {
    padding: 20px;
    border-radius: 10px;
    border: 1px solid var(--ek-split-lineColor);
}

.subtitle {
    font-size: 14px;
    color: var(--ek-text-color2);
}

.lbnum {
    font-size: 25px;
    color: var(--ek-text-color1);
    font-weight: bold;
    margin-top: 10px;
}

.lbuint {
    font-size: 14px;
    color: var(--ek-text-color2);
    font-weight: normal;
    margin-left: 5px;
}

.bnt-main {
    background: var(--ek-color-primary);
    color: white;
    font-size: 14px;
    padding-left: 20px;
    padding-right: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 35px;
    border-radius: 10px;
}

.divhead {
    border-bottom: 1px solid var(--ek-split-lineColor);
    padding-bottom: 20px;
    padding-top: 10px;
}
.atitle {
    color: var(--ek-text-color1);
}
</style>
